import http from '@/utils/http';

const baseUrl = '/bioma';

export default {
    buscar() {
        return http.get({
            url: baseUrl + '/buscar',
            lockScreen: false
        });
    }
};
